import {createContext, useContext, useEffect, useReducer} from "react";
import {initialState, reducer, setBookingList, setQuery, setTotal, setLoading} from "./reducer";
import {useChangeOrderStatus, useListForAppOrPcPage} from "../../../../api/orderReserve";
import {useNavigate} from "react-router";
import {setTabActive} from "../orderList/reducer";
import Dialog from "../../../../publicComponent/Dialog";
import {useTranslation} from "react-i18next";
import useNotice from "../../../../hooks/useNotice";

const Context = createContext(initialState);

function MyBookingController() {
  const { state, dispatch } = useMyBookingContext();
  const { loading, getList } = useListForAppOrPcPage();
  const { cencelOrder } = useChangeOrderStatus();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const notice = useNotice();
  
  const getBookingList = async (query) => {
    let q = { ...state.query, ...query };
    let { data } = await getList(q);
    if (data) {
      dispatch(setQuery(q));
      dispatch(setBookingList(data));
      dispatch(setTotal(Number(data.total)));
    }
  };
  
  const gotoBookingDetail = (item) => {
    navigate(`/bookingOrderDetail?orderId=${item.orderId}`);
  };
  
  /**
   *
   * @param active
   */
  const setTabsActive = (active) => {
    dispatch(setTabActive(active));
    let status = active ? active : '';
    
    getBookingList({
      ...state.query,
      status,
      page: 1,
    });
  };
  
  const getStatus = (status) => {
    switch (status) {
      case '0':
        return '待审核';
      case '1':
        return '通过';
      case '2':
        return '不通过';
      case '3':
        return '已取消';
      case '4':
        return '已完成';
      default:
        return '未知状态';
    }
    return '全部'; // status === false
  };
  
  /**
   * 取消预约
   * @param item
   * @returns {Promise<void>}
   */
  const cancelBooking = async (item) => {
    Dialog.confirm({
      content: t('确定要取消预约吗？'),
      onOk: async (onClose) => {
        let { data } = await cencelOrder({ orderId: item.orderId, status: 3 });
        onClose();
        if (data) {
          notice.success(t('操作成功'));
          getBookingList({ page: 1 });
        }
      }
    });
  };

  /**
   * 地址转换
   */
  const transformAddress = (str) => {
    if(typeof str !== "string" || !str) return
    const areaStrArr = str.split(",")
    return `${t(areaStrArr[0])}${t(areaStrArr[1])}${t(areaStrArr[2])}`
  }
  
  useEffect(() => {
    dispatch(setLoading(loading));
  }, [loading]);
  
  return {
    loading,
    getBookingList,
    setTabsActive,
    gotoBookingDetail,
    getStatus,
    cancelBooking,
    transformAddress
  };
  
}

function useMyBookingContext() {
  const { state, dispatch } = useContext(Context);
  
  return {
    state,
    dispatch,
  };
}

export {useMyBookingContext, MyBookingController};

export default function MyBookingContext({ children }) {
  const [state, dispatch] = useReducer(reducer, initialState);
  
  return (
    <Context.Provider
      value={{ state, dispatch }}
      reducer={reducer}>
      {children}
    </Context.Provider>
  );
}
